module.exports = __webpack_public_path__ + "static/img/bo.6e8b7e0f.svg";